export let gray = '#535353';
export let blue = '#2DD7D7';

export let title = "'Josefin Slab', serif;";
export let text = "'Titillium Web', sans-serif;";
export let special = "'Major Mono Display', monospace;";



